/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable no-cond-assign */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { RecommendationHistoryHeader } from '@bingads-webui-campaign-react/recommendation-history-header';
import { RecommendationHistoryGrid } from '@bingads-webui-campaign/recommendation-history-grid';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HISTORY_PAGE_TAB_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { getHistoryPageStyle } from '../style/history-page-style';

class recommendationsHistory extends React.PureComponent {
  static propTypes = {
    navigateBack: PropTypes.func.isRequired,
    deps: PropTypes.shape({
      appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
      i18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      preferencesService: PropTypes.objectOf(PropTypes.any).isRequired,
    }).isRequired,
    dataService: PropTypes.shape({
      getHistory: PropTypes.func.isRequired,
      downloadHistory: PropTypes.func.isRequired,
    }).isRequired,
    currentActivity: PropTypes.shape({
      trace: PropTypes.func.isRequired,
      error: PropTypes.func.isRequired,
    }).isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    perfMarker: PropTypes.shape({
      willInit: PropTypes.func.isRequired,
      willFetchData: PropTypes.func.isRequired,
      willRender: PropTypes.func.isRequired,
      done: PropTypes.func.isRequired,
      createChild: PropTypes.func.isRequired,
    }),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    isAutoApplyRecommendationEnabled: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    perfMarker: {
      willInit: _.noop,
      willFetchData: _.noop,
      willRender: _.noop,
      done: _.noop,
      createChild: () => this,
    },
  }

  constructor(props) {
    super(props);
    this.perfMarker = props.perfMarker.createChild('RecommendationHistoryGridOverall');
    this.grid = new RecommendationHistoryGrid({
      i18n: props.deps.i18n,
      newI18n: props.newI18n,
      recommendationService: props.dataService,
      appConfig: props.deps.appConfig,
      currentActivity: props.currentActivity,
    }).render();
    if (_.isFunction(this.perfMarker.willInit)) {
      this.perfMarker.willInit();
    }
    this.state = { currentTab: 'All' };
    this.perfMarkerDone = false;
  }

  componentDidMount = () => {
    if (_.isFunction(this.perfMarker.willFetchData)) {
      this.perfMarker.willFetchData();
    }
  };

  componentDidUpdate = () => {
    if (!this.perfMarkerDone) {
      if (_.isFunction(this.perfMarker.done)) {
        this.perfMarker.done();
      }
      this.perfMarkerDone = true;
    }
  }

  filterBySelectedTab = (selectedTab) => {
    this.grid.grid.gridView.set({
      query: _.defaults({
        selectedTab,
      }, this.grid.grid.gridView.get('query')),
    });
    this.setState({ currentTab: selectedTab });
  }

  render() {
    if (_.isFunction(this.perfMarker.willRender)) {
      this.perfMarker.willRender();
    }

    return (
      <div className={this.props.classes.historyPageContainer}>
        <RecommendationHistoryHeader
          i18n={this.props.deps.i18n}
          navigateBack={this.props.navigateBack}
        />
        {this.props.isAutoApplyRecommendationEnabled &&
          <div id="tab-selector-container" >
            <button
              id="all"
              className={`${this.state.currentTab === HISTORY_PAGE_TAB_TYPES.ALL ? 'selected' : ''}`}
              onClick={() => this.filterBySelectedTab(HISTORY_PAGE_TAB_TYPES.ALL)}
            >
              {this.props.newI18n.getString(_TL_(HISTORY_PAGE_TAB_TYPES.ALL))}
            </button>
            <button
              id="manual"
              className={`${this.state.currentTab === HISTORY_PAGE_TAB_TYPES.MANUAL ? 'selected' : ''}`}
              onClick={() => this.filterBySelectedTab(HISTORY_PAGE_TAB_TYPES.MANUAL)}
            >
              {this.props.newI18n.getString(_TL_('Manually applied'))}
            </button>
            <button
              id="auto"
              className={`${this.state.currentTab === HISTORY_PAGE_TAB_TYPES.AUTO ? 'selected' : ''}`}
              onClick={() => this.filterBySelectedTab(HISTORY_PAGE_TAB_TYPES.AUTO)}
            >
              {this.props.newI18n.getString(_TL_('Auto applied'))}
            </button>
          </div>
        }
        <BackboneInstanceWrapper
          instance={this.grid}
        />
      </div>
    );
  }
}

export const RecommendationsHistory =
  withDefaultStyles((recommendationsHistory), getHistoryPageStyle);
